import { useCurrentEditor } from '@tiptap/react';
import { EditorTextStyleButton, HeadingButton, HistoryButtons } from './buttons';
import React from 'react';
import styled from 'styled-components';
import { Link } from './link';
import { Image } from './image';
import { List } from './list';
export function MenuBar() {
    const { editor } = useCurrentEditor();
    if (!editor) {
        return null;
    }
    return (React.createElement(StyledMenuBar, null,
        React.createElement(Group, null,
            React.createElement(HistoryButtons, null)),
        React.createElement(Group, null,
            React.createElement(EditorTextStyleButton, { styleType: "bold", style: { fontWeight: '900' } }),
            React.createElement(EditorTextStyleButton, { styleType: "italic", style: { fontStyle: 'italic' } }),
            React.createElement(EditorTextStyleButton, { styleType: "underline", style: { textDecoration: 'underline' } })),
        React.createElement(Group, null,
            React.createElement(HeadingButton, { level: 1 }),
            React.createElement(HeadingButton, { level: 2 }),
            React.createElement(HeadingButton, { level: 3 }),
            React.createElement(HeadingButton, { level: 4 })),
        React.createElement(Group, null,
            React.createElement(List, null)),
        React.createElement(Group, null,
            React.createElement(Link, null),
            React.createElement(Image, null))));
}
const Group = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
`;
const StyledMenuBar = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-bottom: 5px;
`;
